export default "__VITE_PUBLIC_ASSET__e7aec08f__"